import { Form } from "react-bootstrap";

import { FormControlWrapper } from "./formControlWrapper";

export const FieldTextArea = ({
	isDisabled,
	isForced = false,
	error,
	fieldData,
	placeholder = "",
	formType = "text",
	title = "",
	maxLength,
	autoFocus,
	tooltip,
	setValue = console.log,
}) => (
	<FormControlWrapper
		title={title}
		tooltip={tooltip}
		data-testid="test-fieldTextArea"
		error={error}
	>
		<Form.Control
			as="textarea"
			rows={3}
			value={isForced ? fieldData : undefined}
			data-testid="test-fieldTextAreaControl"
			disabled={isDisabled}
			type={formType}
			defaultValue={fieldData || ""}
			placeholder={placeholder}
			maxLength={maxLength}
			isInvalid={!!error}
			autoFocus={autoFocus}
			onKeyUp={(e) => setValue(e.target.value)}
		/>
	</FormControlWrapper>
);
